export default "__VITE_ASSET__BWGkPY7x__"